import DropdownSelector from '../../components/DropdownSelector'
import useGetIsMobileScreen from '../../hooks/useGetIsMobileScreen'

const REASONS = [
  'Incorrectly entered order',
  'Insufficient inventory',
  'Item returned, quality related',
  'Guest changed their mind',
  'Long wait for item',
]

const customStyling = (isMobileViewPort) => ({
  customAutocompleteStyles: {
    width: isMobileViewPort ? '89.861vw' : '26.900vw',
    height: isMobileViewPort ? '11.111vw' : '3.333vw',
    paddingTop: 0,
    paddingRight: 0,
    borderRadius: 6,
    marginBottom: 5,
  },
  customInputLabelStyles: {
    fontSize: isMobileViewPort ? '4.444vw' : '1.042vw',
    paddingBottom: isMobileViewPort ? '1.111vw' : 0,
    marginTop: isMobileViewPort ? '-0.8vh' : 0,
  },
  customTextFieldStyles: {
    height: isMobileViewPort ? '11.111vw' : '3.333vw',
    fontSize: isMobileViewPort ? '4.444vw' : '1.042vw',
    border: '1px solid #383B3D',
    borderRadius: 6,
    backgroundColor: '#292A2B',
    paddingLeft: 5,
    paddingRight: 15,
    textAlign: 'center',
  },
  customPaperStyles: {
    maxHeight: 'auto',
    backgroundColor: '#292A2B',
    fontSize: isMobileViewPort ? '4.444vw' : '1.042vw',
  },
})

const VNRefundReasons = ({ className, reason = 'Refund Reason', editMode = true, onChange = () => {} }) => {
  const isMobileViewPort = useGetIsMobileScreen()

  const onChangeHandler = (refundReason) => {
    if (!editMode) return
    onChange(refundReason)
  }

  return (
    <div className={className}>
      <DropdownSelector
        autocompleteLabel={reason}
        textInputVariant={'filled'}
        autocompleteOptions={REASONS}
        onAutocompleteChange={onChangeHandler}
        disabled={false}
        {...customStyling(isMobileViewPort)}
      />
    </div>
  )
}

export default VNRefundReasons
